import React from 'react';
import { Box, Typography, Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

const Footer = () => {
  return (
    <Box 
      sx={{ 
        position: 'fixed',
        bottom: 0,
        left: 0,
        width: '100%',
        bgcolor: 'background.default',
        borderTop: '1px solid rgba(0, 0, 0, 0.12)',
        zIndex: 1000,
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        px: 3,
        py: 1.5,
        boxSizing: 'border-box'
      }}
    >
      <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
        <Typography variant="body2" color="text.secondary">
          © 2024-{new Date().getFullYear()} Omnevu.com
        </Typography>
        <Link
          component={RouterLink}
          to="/legal"
          sx={{ color: 'text.secondary', fontSize: '0.875rem' }}
        >
          Terms & Conditions and Privacy Policy
        </Link>
      </Box>
    </Box>
  );
};


export default Footer;
